import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const SpotLightIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M21.4902 18.8946L12.6753 0.673356C12.4243 0.155756 11.5757 0.155756 11.3247 0.673356L2.51028 18.8946C1.90428 20.1456 2.40628 21.671 3.62988 22.295C5.41898 23.2071 8.54788 23.7511 12 23.7511C15.4521 23.7511 18.5801 23.2072 20.3701 22.295C21.5937 21.6729 22.0967 20.1475 21.4902 18.8946ZM19.6904 20.9591C18.124 21.756 15.1777 22.2511 12 22.2511C8.82228 22.2511 5.87498 21.756 4.31098 20.9591C3.80948 20.7032 3.60738 20.0704 3.86028 19.548L12 2.72226L20.1406 19.548V19.549C20.3935 20.0715 20.1914 20.7032 19.6904 20.9591Z"
        fill={color}
      />
      <path
        d="M12.3139 11.4597C12.1196 11.3474 11.8803 11.3474 11.686 11.4597L7.81588 13.7102C7.62348 13.8215 7.50488 14.0276 7.50488 14.2502V18.7502C7.50488 18.9729 7.62358 19.1789 7.81588 19.2902L11.686 21.5402C11.7832 21.5968 11.8916 21.6252 12 21.6252C12.1084 21.6252 12.2168 21.5969 12.314 21.5402L16.1846 19.2902C16.377 19.1789 16.4951 18.9728 16.4951 18.7502V14.2502C16.4951 14.0275 16.3769 13.8215 16.1846 13.7102L12.3139 11.4597ZM11.9999 12.7233L14.6523 14.265L12 15.7801L9.34798 14.2648L11.9999 12.7233ZM8.75478 15.3661L11.3749 16.8632V19.9141L8.75478 18.3908V15.3661ZM12.6249 19.9141V16.8632L15.245 15.3661V18.3908L12.6249 19.9141Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

SpotLightIcon.displayName = 'SpotLightIcon';
